module.exports = require('./pre');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/stage/index.js
// module id = 565
// module chunks = 4